import { SeverityLevelContact } from '../../data/severity-level-contacts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-severity-level-contacts-grid',
  templateUrl: './severity-level-contacts-grid.component.html',
  styleUrl: './severity-level-contacts-grid.component.scss',
  imports: [MatIconModule, RouterModule, MatTooltipModule],
})
export class SeverityLevelContactsGridComponent {
  @Input() severityLevelContacts: SeverityLevelContact[] = [];

  public severityLevelContactRowSpan(
    severityLevelContact: SeverityLevelContact,
  ): number {
    return (
      severityLevelContact.contacts.length +
      ('generalEmail' in severityLevelContact &&
      severityLevelContact.generalEmail !== undefined
        ? 1
        : 0)
    );
  }
}
